module.exports = __webpack_public_path__ + "static/media/estrategia.f4eac99f.svg";